import { z } from 'zod';
export const HealthResponseSchema = z.object({
    status: z.literal('ok'),
    service: z.string(),
    uptime: z.number(),
    version: z.string(),
});
//# sourceMappingURL=schemas.js.map